import { selectAreaMarketInfo } from "../../api";

const echarts = {
  namespaced: true,

  state: () => ({
    areaMarketList: {},
  }),

  getters: {
    areaMarketList: (state) => state.areaMarketList,
  },

  mutations: {
    SET_AREA_MARKET_LIST(state, areaMarketList) {
      state.areaMarketList = areaMarketList;
    },
  },

  actions: {
    async selectMarketByName({ commit }, payload) {
      const { areaName, num } = payload;
      const response = await selectAreaMarketInfo(areaName, num);
      if (response.code === 200) {
        commit("SET_AREA_MARKET_LIST", response.data);
      }
    },
  },
};

export default echarts;
